'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref, _ref2) {
  var invalid = _ref.invalid,
      readOnly = _ref.readOnly,
      styles = _ref.styles,
      touched = _ref.touched,
      value = _ref.value;
  var colors = _ref2.colors,
      fonts = _ref2.fonts,
      radiuses = _ref2.radiuses,
      rhythm = _ref2.rhythm,
      scale = _ref2.scale,
      shadows = _ref2.shadows,
      treatments = _ref2.treatments;

  var isInvalid = touched && invalid;

  var baseStyles = {
    root: {
      display: 'block',
      position: 'relative',
      fontFamily: fonts.body,
      textAlign: 'left',
      marginBottom: rhythm(1)
    },

    fieldWrapper: {
      position: 'relative'
    },

    field: _extends({
      display: 'block',
      width: '100%',
      textAlign: 'left',
      overflow: 'hidden',
      backgroundColor: colors.light,
      color: readOnly ? colors.lightGrey : colors.dark,
      padding: rhythm([0.125, 0.333]),
      paddingRight: rhythm(1.5),
      height: rhythm(1.666),
      border: 'thin solid ' + (isInvalid ? colors.danger : colors.lightGrey),
      boxShadow: isInvalid ? '0 0 5px ' + colors.danger : 'none',
      borderRadius: rhythm(radiuses.small),
      textIndent: value && '-99999px'
    }, treatments.input, {

      '&:focus': {
        borderColor: isInvalid ? colors.danger : colors.secondary,
        boxShadow: '0 0 5px ' + (isInvalid ? colors.danger : colors.secondary)
      }
    }),

    icon: {
      position: 'absolute',
      right: rhythm(0.5),
      top: '50%',
      transform: 'translateY(-50%)',
      cursor: value && 'pointer'
    },

    selected: {
      position: 'absolute',
      left: rhythm(0.5),
      right: rhythm(1.5),
      top: '50%',
      transform: 'translateY(-50%)',
      cursor: 'pointer'
    },

    results: {
      position: 'absolute',
      zIndex: 6,
      maxHeight: rhythm(12),
      overflow: 'auto',
      top: '100%',
      left: 0,
      right: 0,
      backgroundColor: colors.light,
      color: colors.dark,
      boxShadow: shadows.light
    },

    status: {
      padding: rhythm(1),
      textAlign: 'center',
      fontSize: scale(-1),
      opacity: 0.5
    },

    showMore: {
      display: 'block',
      width: '100%',
      padding: rhythm(0.5),
      textAlign: 'center',
      fontSize: scale(-0.5),
      cursor: 'pointer',
      backgroundColor: colors.paleGrey,

      '&:hover': {
        backgroundColor: colors.primary,
        color: colors.light
      }
    }
  };

  return (0, _merge2.default)(baseStyles, styles);
};


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/input-search/styles.js
// module id = 837
// module chunks = 0